import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useEffect } from 'react';

import {
  TRACKING_EVENT_NAMES,
  ACTION_SUBJECT_IDS
} from '../../utils/constants';
import { containerStyle, buttonStyle } from './cart-button.styles';
import { CartIcon } from './cart-icon';

interface CartButtonProps {
  analyticsAttributes: object;
  numberOfProductTrials: number;
  onClick: () => void;
}

const CartButton = ({
  analyticsAttributes,
  numberOfProductTrials,
  onClick
}: CartButtonProps) => {
  const { createAnalyticsEvent } = useAnalyticsEvents();

  useEffect(() => {
    createAnalyticsEvent({
      eventName: TRACKING_EVENT_NAMES.wacCartRendered,
      action: 'rendered',
      actionSubject: 'wacCart',
      actionSubjectId: ACTION_SUBJECT_IDS.wacCartRendered,
      attributes: analyticsAttributes
    }).fire();
  }, []);

  return (
    <div css={containerStyle}>
      <button
        data-testid="cart-button"
        css={buttonStyle}
        onClick={onClick}
        title={`View ${numberOfProductTrials} product ${
          numberOfProductTrials > 1 ? 'trials' : 'trial'
        } ending soon`}
      >
        <CartIcon
          numberOfProductTrials={
            numberOfProductTrials > 5 ? '5 +' : `${numberOfProductTrials}`
          }
        />
      </button>
    </div>
  );
};

export { CartButton };
